import React from 'react'

const ContactUs = () => {
  return (
    <div>
      <div>ContactUs</div>
      <p>
      Welcome to our Properties Selling website! We appreciate your interest and would be delighted to assist you in any way we can. Please feel free to reach out to us using the following contact information:

Customer Support:
If you have any questions, concerns, or require assistance with our website or services, our dedicated customer support team is here to help. You can contact us via:

Phone: 987654321
Email: support@propertypro.in
Hours of Operation: 9am-6pm, Monday-Friday

Sales Inquiries:
For inquiries regarding property listings, buying or selling properties, or any sales-related questions, our experienced sales team is ready to provide you with the information you need. Please get in touch with us through:

Phone: 9928273627
Email: sales@propertypro.in
Hours of Operation: 9am-6pm, Monday-Friday

Technical Support:
If you encounter any technical issues while using our website or need assistance with account-related matters, our technical support team is available to assist you. You can contact them via:

Phone: 9884899383
Email: tech.support@propertypro.in
Hours of Operation: 9am-6pm, Monday-Friday

General Inquiries:
For general questions, feedback, or suggestions, please feel free to get in touch with us through:

Phone: 9938399484
Email: support.queries@propertypro.in
Hours of Operation:   9am-6pm, Monday-Friday

We strive to provide prompt and excellent customer service, and we will make every effort to respond to your inquiries as soon as possible.

Additionally, you may find answers to commonly asked questions and helpful information on our Frequently Asked Questions (FAQ) page, accessible on our website.

We value your feedback and appreciate your interest in our properties selling website. Your satisfaction is important to us, and we are committed to ensuring a smooth and enjoyable experience for all our users.

Thank you for choosing our website, and we look forward to serving you!

Sincerely,
XYZ
CEO, PropertyPro
www.propertypro.in
No.3 & 4, XYZ St.,
Sowcarpet ,
Chennai - 600001
      </p>
    </div>
  )
}

export { ContactUs};